import React, { Component } from 'react';

import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Box from '../ui/Box';
import Select from 'react-select';
import RaisedButton from 'material-ui/RaisedButton';

//providers
import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;

export default class MoveLock extends Component {

    constructor(props) {
        super(props);
        this.state = {
            all_devices: [],
            devicesSelected: "",
            dialog: {
                open: false,
                head: 'Dude',
                body: 'This is working',
                actions: [
                    <FlatButton
                        label="Okay"
                        primary
                        onClick={this.closeDialog.bind(this)}
                    />
                ]
            },

        }
    }

    componentDidMount() {
        console.log("I am ahgsdhsadghas");
        this.getAllDevices();
    }

    getAllDevices() {
        ds.getAllDevices((data) => {
            if (data && data.status == 1) {
                this.setState({
                    all_devices: data.data
                })
            }

        }, (err) => {
            console.log(err);
        })

    }

    moveBack() {

        let devicesList = []

        this.state.devicesSelected.forEach((device) => {
            devicesList.push(device.value);
        });

        let obj = {
            deviceIds: devicesList
        }

        ds.postMoveBackToHome(obj, (data) => {
            if (data && data.status == 1) {
                this.setState({
                    dialog: {
                        open: true,
                        head: 'Success',
                        body: 'Sucessfully moved devices back to Home',
                        actions: [
                            <FlatButton
                                label="Okay"
                                primary
                                onClick={this.closeDialog.bind(this)}
                            />
                        ]
                    },
                })
            }
        }, (err) => {
            console.log(err);
        })

    }

    closeDialog(refresh = 0) {
        this.setState({
            dialog: {
                head: '',
                body: '',
                open: false,
                actions: []
            }
        })
    }


    render() {
       
        return (
            <div>
                <Box header='Move Back Locks,Gateways To Home'>
                    <Dialog
                        title={this.state.dialog.head}
                        actions={this.state.dialog.actions}
                        modal={false}
                        open={this.state.dialog.open}
                        onRequestClose={this.closeDialog.bind(this)}
                    >
                        {this.state.dialog.body || 'NA'}
                    </Dialog>


                    <Select
                        id="device_id"
                        onBlurResetsInput={false}
                        onSelectResetsInput={false}
                        autoFocus
                        options={this.state.all_devices}
                        searchable={true}
                        placeholder="Select Devices"
                        multi={true}
                        value={this.state.devicesSelected}
                        onChange={(newValue) => {
                            this.setState({
                                devicesSelected: newValue,
                            });
                        }}
                    />

                    <RaisedButton
                        label="Move Back To Home"
                        primary
                        type="submit"
                        disabled={this.state.devicesSelected == ''}
                        onClick={() => {
                            this.moveBack();
                        }}
                    />

                </Box>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/movelock/moveBackLockToHome.js